<template>
  <svg
    width="39"
    height="35"
    viewBox="0 0 39 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_33_23)">
      <mask
        id="mask0_33_23"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="32"
        height="32">
        <rect x="2" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_33_23)">
        <path
          d="M9.9974 26.6673C8.53073 26.6673 7.27517 26.1451 6.23073 25.1007C5.18628 24.0562 4.66406 22.8007 4.66406 21.334V10.6673C4.66406 9.20065 5.18628 7.9451 6.23073 6.90065C7.27517 5.85621 8.53073 5.33398 9.9974 5.33398H25.9974C27.4641 5.33398 28.7196 5.85621 29.7641 6.90065C30.8085 7.9451 31.3307 9.20065 31.3307 10.6673V21.334C31.3307 22.8007 30.8085 24.0562 29.7641 25.1007C28.7196 26.1451 27.4641 26.6673 25.9974 26.6673H9.9974ZM9.9974 10.6673H25.9974C26.4863 10.6673 26.953 10.7229 27.3974 10.834C27.8418 10.9451 28.2641 11.1229 28.6641 11.3673V10.6673C28.6641 9.93398 28.403 9.30621 27.8807 8.78398C27.3585 8.26176 26.7307 8.00065 25.9974 8.00065H9.9974C9.26406 8.00065 8.63628 8.26176 8.11406 8.78398C7.59184 9.30621 7.33073 9.93398 7.33073 10.6673V11.3673C7.73073 11.1229 8.15295 10.9451 8.5974 10.834C9.04184 10.7229 9.50851 10.6673 9.9974 10.6673ZM7.53073 15.0007L22.3641 18.6007C22.5641 18.6451 22.7641 18.6451 22.9641 18.6007C23.1641 18.5562 23.353 18.4673 23.5307 18.334L28.1641 14.4673C27.9196 14.134 27.6085 13.8618 27.2307 13.6507C26.853 13.4395 26.4418 13.334 25.9974 13.334H9.9974C9.41962 13.334 8.91406 13.484 8.48073 13.784C8.0474 14.084 7.73073 14.4895 7.53073 15.0007Z"
          fill="#525252" />
      </g>
    </g>
    <g clip-path="url(#clip0_33_23)">
      <path
        d="M31 32C35.4183 32 39 28.4183 39 24C39 19.5817 35.4183 16 31 16C26.5817 16 23 19.5817 23 24C23 28.4183 26.5817 32 31 32Z"
        fill="#525252" />
      <path
        d="M33.241 22.7311V25.6318L30.8984 26.9665V29.4628L35.8408 26.6009V21.2266L33.241 22.7311Z"
        fill="#1E192E" />
      <path
        d="M28.7156 25.6784V22.8198L26.1562 21.3379V26.7235L30.898 29.4738V26.9613L28.7156 25.6784Z"
        fill="#1E192E" />
      <path
        d="M33.8796 20.0173L28.7107 22.8258L26.1562 21.3375L31.33 18.5273L33.8796 20.0173Z"
        fill="#1E192E" />
    </g>
    <defs>
      <filter
        id="filter0_d_33_23"
        x="0.664062"
        y="5.33398"
        width="34.6641"
        height="29.334"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_23" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_23"
          result="shape" />
      </filter>
      <clipPath id="clip0_33_23">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(23 16)" />
      </clipPath>
    </defs>
  </svg>
</template>
